{
	"flagPhoto": "Flag photo",
	"howToCull": "How to Cull Your Photos",
	"howToCullDescription": "Use flags, star ratings or color labels to select your best photos.",
	"rejectPhoto": "Reject photo",
	"removeStarRating": "Remove star rating",
	"setColorLabel": "Set color label",
	"setStarRating": "Set star rating",
	"unflagPhoto": "Unflag photo"
}
